import React from "react";
import "./Privacy.css";

const Privacy = () => {
  return (
    <div className="privacy-container">
      <section className="privacy-section">
        <h1 className="privacy-heading">Shalom Privacy Policy</h1>

        <p className="privacy-intro">
          Shalom Domestic Agencies (“Shalom”, “we”, “us”) is committed to protecting your privacy
          and handling your personal data responsibly. This Privacy Policy explains how we collect,
          use, share, and protect your information when you use the Shalom mobile app, website,
          and related services (“Services”).
        </p>

        <h2>1. Information we collect</h2>
        <p className="privacy-paragraph">We may collect the following categories of information:</p>
        <ul className="privacy-list">
          <li><strong>Account information:</strong> name, phone number, email address, password (stored in encrypted/hashed form).</li>
          <li><strong>Profile & preferences:</strong> location area, service preferences, household requirements you choose to provide.</li>
          <li><strong>Order & service information:</strong> service requests, booking details, confirmations, and communication required to fulfill an order.</li>
          <li><strong>Payments information:</strong> payment references/transaction identifiers and status (we do not store your M-Pesa PIN).</li>
          <li><strong>Ratings & reviews:</strong> feedback you provide about bureaus, househelps, and Mama Fua providers.</li>
          <li><strong>Device & usage information:</strong> app usage, device identifiers, crash logs, and analytics to improve reliability and security.</li>
        </ul>

        <h2>2. How we use your information</h2>
        <ul className="privacy-list">
          <li><strong>Provide the Services:</strong> create and manage your account, enable bookings, and support fulfillment.</li>
          <li><strong>Facilitate service delivery:</strong> share limited details (e.g., name, phone, location area, order details) with a bureau or service provider for fulfillment only.</li>
          <li><strong>Payments and reconciliation:</strong> confirm payment status, handle refunds where applicable, and keep transaction audit records.</li>
          <li><strong>Safety, fraud prevention & enforcement:</strong> detect suspicious activity, investigate complaints, enforce our terms, and keep the platform safe.</li>
          <li><strong>Improve our platform:</strong> analytics, feature improvements, and customer support.</li>
        </ul>

        <h2>3. Mama Fua services and payments</h2>
        <p className="privacy-paragraph">
          Shalom enables bookings for Mama Fua services (laundry/cleaning-related services). Payment flows may include:
        </p>
        <ul className="privacy-list">
          <li><strong>Deposit payments:</strong> where applicable, you may pay a deposit through the platform to confirm the booking.</li>
          <li><strong>Balance payments:</strong> any remaining balance may be paid <strong>directly to the Mama Fua service provider</strong> after service delivery, as agreed during booking.</li>
          <li><strong>Records:</strong> we retain booking records, confirmations, and payment status/references to support disputes, refunds (where applicable), and compliance.</li>
        </ul>

        <h2>4. How we share your information</h2>
        <p className="privacy-paragraph">
          We do not sell your personal data. We share data only as needed:
        </p>
        <ul className="privacy-list">
          <li><strong>With bureaus/service providers:</strong> your name, phone number, location area, and booking details to fulfill your request.</li>
          <li><strong>With payment and technical partners:</strong> to process payments, host infrastructure, send notifications, and secure the platform.</li>
          <li><strong>For legal reasons:</strong> where required by law, court order, or to protect rights, users, and public safety.</li>
        </ul>

        <h2>5. Safety, responsibility, and incident handling</h2>
        <p className="privacy-paragraph">
          Shalom is a platform that helps connect clients with bureaus and service providers. We take safety seriously and
          may assist with investigations, suspensions, and information-sharing where lawful and necessary. However:
        </p>
        <ul className="privacy-list">
          <li><strong>Client safety measures matter:</strong> you are responsible for taking reasonable precautions (e.g., securing valuables, confirming identity where possible, supervising access, and using verified contacts).</li>
          <li><strong>Use ratings and reviews:</strong> ratings/reviews exist to help the community make safer choices; always consider provider history before confirming.</li>
          <li><strong>Incidents (loss/theft/damage):</strong> if an incident occurs, report it to Shalom support as soon as possible with booking details. We may help by reviewing platform records and taking action on the provider’s account, but ultimate responsibility and remedies may depend on the service provider/bureau relationship and applicable law.</li>
        </ul>

        <h2>6. Data security</h2>
        <ul className="privacy-list">
          <li><strong>Encryption & secure storage:</strong> passwords are stored securely (hashed/encrypted) and access is restricted.</li>
          <li><strong>Access control:</strong> only authorized personnel can access sensitive data, and only for legitimate purposes.</li>
          <li><strong>Monitoring:</strong> we use reasonable technical and organizational measures to prevent unauthorized access.</li>
        </ul>

        <h2>7. Data retention</h2>
        <p className="privacy-paragraph">
          We retain your data as long as necessary to provide the Services, comply with legal obligations, resolve disputes,
          and enforce agreements. If you delete your account, we will delete or anonymize data where feasible, subject to
          legal and operational requirements (e.g., transaction logs).
        </p>

        <h2>8. Your rights</h2>
        <ul className="privacy-list">
          <li><strong>Access & correction:</strong> request access to your data and correct inaccuracies.</li>
          <li><strong>Deletion:</strong> request deletion of your account and personal data where applicable.</li>
          <li><strong>Objection/complaints:</strong> contact us with concerns and we will respond within a reasonable time.</li>
        </ul>

        <h2>9. Changes to this policy</h2>
        <p className="privacy-paragraph">
          We may update this policy as our Services change. Material updates will be communicated via the app, website,
          or email. Continued use after updates means you accept the revised policy.
        </p>

        <h2>10. Contact us</h2>
        <p className="privacy-paragraph">
          For privacy questions, requests, or complaints contact:{" "}
          <a href="mailto:shalomke98@gmail.com" className="privacy-contact-email">
            shalomke98@gmail.com
          </a>
        </p>
      </section>

      <section className="delete-account-section">
        <h2 className="privacy-heading">Delete Your Account</h2>
        <p>
          To request deletion of your account and associated data, use:{" "}
          <a href="https://shalomdomestics.co.ke/deletion" className="delete-account-link">
            Delete My Account
          </a>
        </p>
      </section>

      <section className="thank-you">Thank you for using Shalom!</section>
    </div>
  );
};

export default Privacy;